import {isNotNil} from 'ramda';
import {isString} from 'ramda-adjunct';

import {getSafely, Nullish} from 'shared/web';

export type VehicleHistoryJobRow = {
  id: string;
  serviceCaseId: string | Nullish;
  serviceOrderId: string | Nullish;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return isNotNil(value) && typeof value === 'object' && !Array.isArray(value);
}

function readCellValue(row: Record<string, unknown>, column: string) {
  const cell = getSafely(row, column);

  if (!isRecord(cell) || !isString(cell.value)) {
    return undefined;
  }

  return cell.value;
}

/**
 * Datagrid rows arrive untyped. Returns null for anything that is not a usable service request
 * row so callers can skip it instead of copying a half-built item.
 */
export function parseVehicleHistoryJobRow(row: unknown) {
  if (!isRecord(row) || !isString(row.id)) {
    return null;
  }

  return {
    id: row.id,
    serviceCaseId: readCellValue(row, 'serviceCaseId'),
    serviceOrderId: readCellValue(row, 'serviceOrderId'),
  };
}
